import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoader:false,
  allBanners:[],
}

export const bannerSlice = createSlice({
  name: 'allBanner',
  initialState,
  reducers: {
    getBannerStart: (state,action) => {
        state.isLoader= true
    },
    getBannerSuccess: (state,action) => {
        state.isLoader= false
        state.allBanners = action.payload
    },
    deleteBanner:(state,action) => {
      state.isLoader = true
      state.allBanners = state.allBanners.filter((elem)=>elem._id !== action.payload)
      state.isLoader = false

    },
  },
})

export const {getBannerStart, getBannerSuccess, deleteBanner, } = bannerSlice.actions

export default bannerSlice.reducer